import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface AuthState {
  isAuthenticated: boolean
  userId: string | null
  apiKey: string | null
  installId: string | null
  installSecret: string | null
  nocodbJobsViewUrl: string | null
  nocodbScheduledViewUrl: string | null
  email: string | null
  username: string | null
  creditsBalance: number | null
  login: (data: {
    userId: string
    apiKey: string
    installId?: string
    installSecret?: string
    nocodbJobsViewUrl?: string
    nocodbScheduledViewUrl?: string
    email?: string
    username?: string
    creditsBalance?: number
  }) => void
  logout: () => void
  checkUrlParams: () => void
  updateCreditsBalance: (balance: number) => void
  updateProfile: (data: { email?: string; username?: string }) => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      isAuthenticated: false,
      userId: null,
      apiKey: null,
      installId: null,
      installSecret: null,
      nocodbJobsViewUrl: null,
      nocodbScheduledViewUrl: null,
      email: null,
      username: null,
      creditsBalance: null,

      login: (data) => {
        set({
          isAuthenticated: true,
          userId: data.userId,
          apiKey: data.apiKey,
          installId: data.installId || null,
          installSecret: data.installSecret || null,
          nocodbJobsViewUrl: data.nocodbJobsViewUrl || null,
          nocodbScheduledViewUrl: data.nocodbScheduledViewUrl || null,
          email: data.email || null,
          username: data.username || null,
          creditsBalance: data.creditsBalance ?? null,
        })
      },

      logout: () => {
        set({
          isAuthenticated: false,
          userId: null,
          apiKey: null,
          installId: null,
          installSecret: null,
          nocodbJobsViewUrl: null,
          nocodbScheduledViewUrl: null,
          email: null,
          username: null,
          creditsBalance: null,
        })
      },

      checkUrlParams: () => {
        const params = new URLSearchParams(window.location.search)
        const installId = params.get('officex_install_id')
        const installSecret = params.get('officex_install_secret')
        const customerId = params.get('officex_customer_id')

        // If URL has different install credentials, clear and re-login
        const current = get()
        if (installId && installSecret) {
          if (current.installId !== installId) {
            // Different user - clear session
            set({
              isAuthenticated: false,
              userId: null,
              apiKey: null,
              installId: null,
              installSecret: null,
              nocodbJobsViewUrl: null,
              nocodbScheduledViewUrl: null,
              email: null,
              username: null,
              creditsBalance: null,
            })
          }
        }
      },

      updateCreditsBalance: (balance: number) => {
        set({ creditsBalance: balance })
      },

      updateProfile: (data) => {
        set({
          email: data.email ?? get().email,
          username: data.username ?? get().username,
        })
      },
    }),
    {
      name: 'daily-instagram-story-auth',
    }
  )
)
